import {
  Typography,
  Checkbox,
  Row,
  Col,
  Form,
  Button,
  Collapse,
  Tooltip,
} from "antd";

import {
  DownOutlined,
  RightOutlined,
  CloseCircleTwoTone,
} from "@ant-design/icons";
// import { duration } from "moment";
const { Panel } = Collapse;
const CourseFilterHelper = ({
  title,
  name,
  items,
  valueKey,
  labelKey,
  countKey = "count",
  form,
  isVisible,
  toggle,
  showClear = false,
  onClear,
}) => (
  <div style={{ marginInline: 10 }}>
    <div className="splitter-first-div" onClick={() => toggle(name)}>
      <Typography.Text
        className="my-form-lables"
        style={{ margin: 0, padding: 0, paddingInline: "5px" }}
      >
        {title}
      </Typography.Text>
      <div>
        {showClear && form.getFieldValue(name)?.length > 0 && (
          <Tooltip title={`Clear ${title}`}>
            <CloseCircleTwoTone
              style={{ cursor: "pointer", fontSize: 16, marginRight: 2.5 }}
              onClick={(e) => {
                e.stopPropagation();
                onClear?.();
              }}
            />
          </Tooltip>
        )}
        <Button
          type="text"
          icon={isVisible ? <DownOutlined /> : <RightOutlined />}
          size="small"
        />
      </div>
    </div>

    <Collapse activeKey={isVisible ? ["1"] : []} ghost>
      <Panel key="1" showArrow={false}>
        <Form.Item name={name} style={{ margin: 0 }}>
          <Checkbox.Group>
            <Row gutter={[16, 8]} style={{ marginTop: 0 }}>
              {items
                ?.filter((x) => x[countKey] > 0)
                ?.map((x, i) => (
                  <Col
                    key={i}
                    span={24}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox value={x[valueKey]}>{x[labelKey]}</Checkbox>
                    <span
                      style={{
                        fontSize: 12,
                        color: "#899499",
                        fontWeight: 600,
                        letterSpacing: 0.5,
                      }}
                    >
                      {x[countKey] ?? 0}
                    </span>
                  </Col>
                ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Panel>
    </Collapse>
  </div>
);

export default CourseFilterHelper;
